import { TextField } from "@mui/material";
import { useEffect, useState } from "react";
import NumberFormat from "react-number-format";

import { debounce } from "../hooks/debounce";


export default function PhoneNumber({value,setValue, field, url, label="Phone", delay=1000, onKeyUp}) {


  const [first, setFirst] = useState(false); // don't fire debounce on first render

  useEffect(() => {
          let db = debounce(url, field, value, first, delay);
          setFirst(true);
          return db;
        }, [value]);
        
  
  if (!value && !setValue) return <div>No Phone number</div>;

  if(!setValue) return (
    <NumberFormat
      value={value}
      format="(###) ###-####"
      displayType={"text"}
    />
  );


  const update = (newValue) => {
    setValue(newValue.value);
  };

  return <NumberFormat
    value={value}
    onValueChange={update}
    customInput={TextField}
    format="(###) ###-####"
    displayType={setValue ? "input" : "text"}
    label={label}
    onKeyUp={onKeyUp}
  />;
}
